<template>
    <div class="header">
        <div class="headerLeft">
            <div class="workspaceImg">
                <!--                <img src="@/assets/images/logo.png" alt="" style="width: 130px;height: 37px"/>-->
                <h1 class="sidebar-title" >智慧水务</h1>
            </div>
        </div>
        <div class="headerRight" v-if="this.$store.state.isLogin">

            <div class="personalCenter" @click="showPersonalCenter = !showPersonalCenter">
                <img src="@/assets/images/icon.png" alt="" class="personalCenterImage">
                <div class="tanChuang" v-if="showPersonalCenter">
                    <div class="caoZuo" @click="logout">退出系统</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Login from "@/views/Login.vue"
    import {removeToken,getUserInfo,setUserInfo} from "../../utils/dataStorage";

    export default {
        name: 'HeaderBar',
        data() {
            return {
                showPersonalCenter: false,//是否显示个人中
                showSwitchTeam: false,//是否显示团队切换框
                companyList: [],
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            /**
             * 这里还要走后端逻辑
             */
            logout() {
                this.$post(this.$url.outLogin, {}).then(resp => {
                    //删除本地存放的token
                    removeToken();
                    //触发vuex 的store更新
                    this.$store.commit('isLogin')
                    this.$notify({
                        title: '已注销',
                        message: '页面即将跳转到网站首页...',
                        type: 'success',
                        duration: 1500,
                        offset: 50
                    })
                    this.$router.push('/login')
                }).catch(() => {
                });
            },
            gotoPersonal(){
                this.$router.push('/personalinfo')
            },
            /**
             * 获取公司列表
             */
            getCompanyList(){
                this.$post(this.$url.公司列表, {},true).then(resp => {
                    this.companyList = resp;
                }).catch(() => {
                });
            },

            async showSelectTeamWindow() {
                if (this.showSwitchTeam) {
                    this.showSwitchTeam = false;
                } else {
                    await this.getCompanyList();
                    this.showSwitchTeam = true;
                }

            },

            /**
             * 切换公司
             * @param company 公司信息
             */
            switchCompany(company) {
                this.$post(this.$url.选择公司, {pid: company.pid}).then((res) => {
                    let user = this.getUserInfo();
                    user.companyName = company.companyName;
                    setUserInfo(user);
                    this.$router.go(0)
                }).catch((err) => {
                });
            },


            getUserInfo(){
                return getUserInfo();
            },

            init(){
                this.getCompanyList();
            },


        },
        components: {
            Login
        }
    }
</script>

<style scoped lang="less">
    .header {
        height: 100%;
        width: 100vw;
        background-color: #e9eef3;
    }

    .headerLeft {
        float: left;
        width: 11vw;
        height: 100%;
        background-color:rgb(48, 65, 86);

        .workspaceImg {
            height: 100%;
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            //background-color: rgb(0,40,77);
            color: #e9eef3;
            font-size: 30px;
            border-bottom: 1px solid #5e5e61;

            .sidebar-title {
                display: inline-block;
                margin: 0;
                color: #fff;
                font-weight: 600;
                line-height: 50px;
                font-size: 22px;
                font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
                vertical-align: middle;
            }
        }
    }



    .headerRight {
        float: left;
        line-height: 60px;
        background: rgba(255, 255, 255);
        margin-left: 5px;
        width: 88vw;
        position: relative;

        .personalCenter {
            width: 60px;
            height: 60px;
            float: right;
            margin-right: 20px;
            /*上下居中*/
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            /*小手*/
            cursor: pointer;
            position: relative;

            /*图片半圆*/

            .personalCenterImage {
                width: 45px;
                height: 45px;
                background: rgba(0, 0, 0, 0);
                border-radius: 50%;
                opacity: 1;
            }


            /*弹窗*/

            .tanChuang {
                z-index: 9999;
                position: absolute;
                width: 243px;
                height: 150px;
                background: rgba(255, 255, 255);
                border: 1px solid #EAEDF7;
                border-radius: 11px;
                top: 60px;
                right: -20px;


                .caoZuo {
                    width: 221px;
                    height: 61px;
                    background: rgba(63, 140, 255, 0.1);
                    border-radius: 11px;
                    margin: 11px auto 0;

                    font-size: 19px;
                    font-weight: 400;
                    line-height: 61px;
                    color: #0A1629;
                    text-align: center;
                    /*小手*/
                    cursor: pointer;
                }

            }


        }
    }


    .teamNameClass {
        width: 352px;
        font-size: 22px;
        font-weight: 500;
        line-height: 60px;
        color: #242F57;
        opacity: 1;
        margin-left: 10px;
        letter-spacing: 2px;
        float: left;
    }

    .switchTeamWindow {
        width: 352px;
        max-height: 300px;
        min-height: 100px;
        overflow: auto;
        background: rgba(255, 255, 255);
        border: 1px solid #EAEDF7;
        box-shadow: 0 8px 35px rgba(121, 145, 173, 0.2);
        border-radius: 11px;
        z-index: 9999;
        position: absolute;
        top: 68px;

        .switchTeamItem {

            width: 331px;
            height: 40px;
            background: rgba(63, 140, 255, 0.05);
            border-radius: 11px;
            margin: 9px auto;
            text-align: left;
            line-height: 40px;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: space-between;


            .switchTeamItemTxt {
                float: left;
                margin-left: 10px;
                font-weight: 400;
                color: #525860;
                font-size: 16px;
                width: 255px;
                overflow: hidden; /*溢出隐藏*/
                text-overflow: ellipsis; /*以省略号...显示*/
                white-space: nowrap; /*强制不换行*/

            }

            .selectClass {
                width: 55px;
                height: 40px;
                display: -webkit-flex;
                display: flex;
                -webkit-align-items: center;
                align-items: center;
                -webkit-justify-content: center;
                justify-content: center;
                margin-right: 10px;

                .dangQianTxt {
                    width: 64px;
                    height: 29px;
                    background: rgba(63, 202, 86);
                    border-radius: 3px;
                    float: left;
                    font-size: 9px;
                    font-weight: 400;
                    line-height: 29px;
                    color: #FFFFFF;
                    opacity: 1;
                    text-align: center;
                }

            }

        }

    }


</style>
